import React from "react";
import PropTypes from "prop-types";
import HUGuideTableManager from "./HUGuideTableManager";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import HUGuideTable from "./HUGuideTable";

const MeasurementDataset = [
  {
    color: "#371822",
    name: "SFat",
    description: "(Subcutaneous Fat)",
    "HU-Value": "-190 ~ -30",
  },
  {
    color: "#452781",
    name: "VFat",
    description: "(Visceral Fat)",
    "HU-Value": "-190 ~ -30",
  },
  {
    color: "#e3df02",
    name: "IMAT",
    description: "(Intermuscular Adipose Tissue)",
    "HU-Value": "-190 ~ -30",
  },
  {
    color: "#00d1d4",
    name: "LAMA",
    description: "(Low Attenuation Muscle)",
    "HU-Value": " -29 ~ 29",
  },
  {
    color: "#a80a02",
    name: "NAMA",
    description: "(Normal Attenuation Muscle)",
    "HU-Value": "  30 ~ 150",
  },
];

class HUGuideTableConatiner extends React.Component {
  static propTypes = {
    enterTimeout: PropTypes.number,
    leaveTimeout: PropTypes.number,
  };

  static defaultProps = {
    enterTimeout: 400,
    leaveTimeout: 400,
  };

  state = {
    notification: {},
  };

  componentWillMount = () => {
    HUGuideTableManager.addChangeListener(this.handleShowRequest);
  };

  componentWillUnmount = () => {
    HUGuideTableManager.removeChangeListener(this.handleShowRequest);
  };

  handleShowRequest = (notification) => {
    this.setState(notification);
  };

  handleRequestHide = (notification) => {
    //HUGuideTableManager.remove(notification);
    HUGuideTableManager.remove({});
  };

  render() {
    const { id, isShow } = this.state;
    const { enterTimeout, leaveTimeout } = this.props;
    return (
      <React.Fragment>
        {<HUGuideTable key={id} dataset={MeasurementDataset} open={isShow} />}
      </React.Fragment>
    );
  }
}

export default HUGuideTableConatiner;
